<template>
  <div class="mycomment">
    <div v-if="showPage">
      <div v-if="commentType == 1">
        <ul class="comment_list" v-if="commentList.length>0">
          <li v-for="item in commentList">
            <div @click="toGoodsList(item.supplierId, item.supplierShortName)" class="comment_top arrow-right">
              <span class="dp_img fl" :style="{backgroundImage:'url('+item.shopLogoUrl+')'}"></span>
              <span class="shop_name fl">{{item.supplierShortName}}</span>
            </div>
            <div style="padding-left: 0.84rem;">
              <span class="line"></span>
              <div class="score_star">
                <span>评分</span>
                <CommentStars :qualityCode="item.qualityCode"></CommentStars>
                <span class="time fl" style="margin-left: 0.4rem">时间：{{item.date}}</span>
              </div>
              <div class="comment_des">{{item.comment}}</div>
              <PreviewPicture :previewPictures='item.urls' v-if="item.urls && item.urls.length>0"></PreviewPicture>
              <div class="goodsmark_list" v-if="item.goodsMarkList.length > 0">
                <div><span class="icon good" v-if="item.goodList.length > 0"></span><p><span v-for="(item1,index) in item.goodList">{{item1}}<span v-if="index < item.goodList.length-1">，</span></span></p></div>
                <div><span class="icon bad" v-if="item.badList.length > 0"></span><p><span v-for="(item2, index) in item.badList">{{item2}}<span v-if="index < item.badList.length-1">，</span></span></p></div>
              </div>
              <div v-if="item.isReply==1" class="reply_comment">商家回复：{{item.replyComment}}</div>
              <div class="comment_bottom">
                <div @click="deleteComment(item.id)" class="delete fr">删除</div>
              </div>
            </div>
          </li>
        </ul>
        <div class="no-info" v-else>
          <div class="no-goods">
            <img src="../assets/images/empty-01.png" />
            <p>这里什么都没有</p>
          </div>
        </div>
      </div>
      <div v-else>
        <ul class="comment_list">
          <li>
            <div @click="toGoodsList(commentDetail.supplierId, commentDetail.supplierShortName)" class="comment_top arrow-right">
              <span class="dp_img fl" :style="{backgroundImage:'url('+commentDetail.shopLogoUrl+')'}"></span>
              <span class="shop_name fl">{{commentDetail.supplierShortName}}</span>
            </div>
            <div style="padding-left: 0.84rem;">
              <span class="line"></span>
              <div class="score_star">
                <span>评分</span>
                <CommentStars :qualityCode="commentDetail.qualityCode"></CommentStars>
                <span class="time fl" style="margin-left: 0.4rem">时间：{{commentDetail.date}}</span>
              </div>
              <div class="comment_des">{{commentDetail.comment}}</div>
              <PreviewPicture :previewPictures='commentDetail.urls' v-if="commentDetail.urls && commentDetail.urls.length>0"></PreviewPicture>
              <div class="goodsmark_list" v-if="commentDetail.goodsMarkList && commentDetail.goodsMarkList.length > 0">
                <div><span class="icon good" v-if="commentDetail.goodList && commentDetail.goodList.length > 0"></span><p><span v-for="(item1,index) in commentDetail.goodList">{{item1}}<span v-if="index < commentDetail.goodList.length-1">，</span></span></p></div>
                <div><span class="icon bad" v-if="commentDetail.badList && commentDetail.badList.length > 0"></span><p><span v-for="(item2, index) in commentDetail.badList">{{item2}}<span v-if="index < commentDetail.badList.length-1">，</span></span></p></div>
              </div>
              <div v-if="commentDetail.isReply==1" class="reply_comment">商家回复：{{commentDetail.replyComment}}</div>
              <div class="comment_bottom">
                <div @click="deleteComment(commentDetail.estimateId)" class="delete fr">删除</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
    import {actions} from '../store/actions'
    import PreviewPicture from '../components/PreviewPicture'
    import CommentStars from '../components/CommentStars'
    // import { MessageBox, Toast } from 'mint-ui'

    export default {
      data () {
        return {
          showPage: false,
          commentType: window.localStorage.getItem('commentType'),
          orderId: window.localStorage.getItem('orderCode'),
          estimateId: window.localStorage.getItem('estimateId'),
          currentPage: 1,
          pageSize: 20,
          hasMore: true,
          commentList:[],
          commentDetail: {}
        }
      },
      created (){
        var _this = this
        if(_this.commentType == 0){
          document.title = "评论详情"
        }else if(_this.commentType == 1){
          document.title = "我的评论"
        }
        _this.getCommentList()

        //页面滚动到底部触发事件
        window.onscroll = function () {
          var marginBot = 0
          if (document.documentElement.scrollTop){
            marginBot = document.documentElement.scrollHeight
              -(document.documentElement.scrollTop + document.body.scrollTop)
              - document.documentElement.clientHeight
          } else {
            marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight
          }
          if(marginBot <= 0) {
            if(_this.hasMore) {
              _this.getCommentList()
            }
          }
        };
      },
      methods: {
        getCommentList: function () {
          var _this = this
          _this.hasMore = false
          if(_this.commentType == 0){ //评价详情
            var params = {
              id: _this.estimateId
            }
            actions.getCommentDetails(_this, params, function (data) {
              _this.showPage = true;
              _this.commentDetail = data;
              // console.log(_this.commentDetail)
              _this.commentDetail.goodList = []
              _this.commentDetail.badList = []
              if(_this.commentDetail.goodsMarkList){
                if( _this.commentDetail.goodsMarkList.length > 0){
                  for (var m = 0; m < _this.commentDetail.goodsMarkList.length; m++) {
                    if(_this.commentDetail.goodsMarkList[m].goodsScore == 2){
                      _this.commentDetail.goodList.push(_this.commentDetail.goodsMarkList[m].goodsName)
                    }else if(_this.commentDetail.goodsMarkList[m].goodsScore == 1){
                      _this.commentDetail.badList.push(_this.commentDetail.goodsMarkList[m].goodsName)
                    }
                  }
                }
              }
            })
          }else if (_this.commentType == 1){
            var params = {
              id: _this.orderId,
              pageSize: _this.pageSize,
              pageNo: _this.currentPage
            }
            actions.getCommentList(_this, params, function (data) {
              _this.showPage = true;
              if(data.list.length < _this.pageSize) {
                _this.hasMore = false
              } else {
                _this.hasMore = true
              }
              _this.currentPage = _this.currentPage +1;

              if(data.list.length > 0) {
                var commentList = data.list;
                for (var i = 0; i < commentList.length; i++) {
                  _this.commentList.push(commentList[i])
                }
                for (var i = 0; i < _this.commentList.length; i++) {
                  _this.commentList[i].goodList = []
                  _this.commentList[i].badList = []
                  for (var m = 0; m < _this.commentList[i].goodsMarkList.length; m++) {
                    if(_this.commentList[i].goodsMarkList[m].goodsScore == 2){
                      _this.commentList[i].goodList.push(_this.commentList[i].goodsMarkList[m].goodsName)
                    }else if(_this.commentList[i].goodsMarkList[m].goodsScore == 1){
                      _this.commentList[i].badList.push(_this.commentList[i].goodsMarkList[m].goodsName)
                    }
                  }

                }
              }
            })
          }
        },
        toGoodsList: function (id, name) {
          var _this = this
          var obj = {
            shop_code: id,
            shop_name: name,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({name:'GoodsList'})
        },
        deleteComment: function (id) {
          var _this = this
          console.log(id);
          _this.estimateId = id;
          _this.$messagebox.confirm('确认删除这条评价吗','').then(action => {
            var params = {
              estimateId: _this.estimateId
            };
            actions.getDeleteComment(_this, params, function (data) {
              if(data == 1) {
                _this.$toast('评价删除成功')
                _this.currentPage = 1;
                _this.showPage = false;
                _this.commentList = [];
                _this.getCommentList();
                window.localStorage.removeItem('estimateId')
              }
            },function(data){
              _this.$messagebox.alert(data.body.message,'')
            })
          }).catch(() => {

          })
        }
      },
      components: {
        PreviewPicture,
        CommentStars
      }
    }

</script>




// WEBPACK FOOTER //
// MyComment.vue?67b67512